export const SERVICE_ID = "service_bcypjky"
export const USER_ID = "0oCkCHY_n2mjWQfzg"
export const TEMPLATE_ID = "template_jz76zts"
